module.exports = __webpack_public_path__ + "img/Soga-om-Gunnlaug-Ormstunge_Viking-under-lydklipp-med-Illuges-drom.0548e192.jpg";